export const translations = {
  es: {
    // Navbar
    nav: {
      home: "Inicio",
      services: "Servicios",
      successCases: "Casos de Éxito",
      contact: "Contacto",
      back: "Volver"
    },

    // Home Section
    home: {
      hero: {
        title: "Transformamos tu",
        titleHighlight: "Visión Digital",
        subtitle: "Somos una consultora IT especializada en crear soluciones tecnológicas innovadoras que impulsan el crecimiento de tu negocio."
      },
      stats: {
        projects: "Proyectos Completados",
        clients: "Clientes Satisfechos",
        experience: "Años de Experiencia"
      },
      cta: {
        startProject: "Comenzar Proyecto",
        viewServices: "Ver Servicios",
        registerNow: "Registrarse Ahora",
        learnMore: "Conocer Más"
      },
      trust: {
        title: "Confían en nosotros:"
      }
    },

    // Services Section
    services: {
      title: "Nuestros Servicios",
      subtitle: "Ofrecemos soluciones tecnológicas integrales para impulsar tu negocio hacia el futuro digital.",
      services: [
        {
          title: "Desarrollo Web",
          description: "Creamos sitios web modernos, responsivos y optimizados para SEO que convierten visitantes en clientes.",
          price: "Desde 500 €",
          extraLink: {
            text: "Más info sobre posicionamiento SEO",
            url: "posicionamiento-seo"
          }
        },
        {
          title: "Aplicaciones Móviles",
          description: "Desarrollamos apps nativas e híbridas para iOS y Android con las mejores prácticas de UX/UI.",
          price: "Desde 8.000 €"
        },
        {
          title: "Consultoría IT",
          description: "Asesoramiento estratégico para optimizar procesos tecnológicos y mejorar la eficiencia operativa.",
          price: "Desde 120 €/hora"
        },
        {
          title: "Cloud & DevOps",
          description: "Implementamos infraestructuras cloud escalables y automatizamos procesos de desarrollo y despliegue.",
          price: "Desde 2.500 €"
        },
        {
          title: "Inteligencia Artificial",
          description: "Desarrollamos soluciones de IA y machine learning para automatizar procesos y extraer insights valiosos.",
          price: "Desde 15.000 €"
        },
        {
          title: "Ciberseguridad",
          description: "Protegemos tu infraestructura digital con servicios avanzados de seguridad informática y auditorías de vulnerabilidades.",
          price: "Desde 5.000 €"
        },
        {
          title: "E-commerce",
          description: "Creamos tiendas online completas y funcionales que convierten visitantes en clientes y maximizan tus ventas.",
          price: "Desde 6.500 €"
        },
        {
          title: "Marketing en RRSS",
          description: "Gestionamos tu presencia en redes sociales para aumentar tu visibilidad y engagement con tu audiencia.",
          price: "Desde 1.200 €/mes"
        },
        {
          title: "Automatización de Procesos",
          description: "Automatizamos procesos repetitivos para mejorar la eficiencia operativa y reducir costos de tu empresa.",
          price: "Desde 4.500 €"
        },
        {
          title: "Análisis de Datos y BI",
          description: "Transformamos datos en insights valiosos para la toma de decisiones estratégicas de tu negocio.",
          price: "Desde 8.500 €"
        },
        {
          title: "Integración de Sistemas",
          description: "Conectamos tus sistemas empresariales para optimizar flujos de trabajo y mejorar la eficiencia.",
          price: "Desde 7.500 €"
        },
        {
          title: "APIs y Microservicios",
          description: "Desarrollamos APIs robustas y arquitecturas de microservicios para aplicaciones escalables.",
          price: "Desde 5.500 €"
        },
        {
          title: "Marketing Corporativo",
          description: "Desarrollamos estrategias de marketing B2B y corporativo para posicionar tu empresa en el mercado empresarial.",
          price: "Desde 2.500 €/mes"
        },
        {
          title: "Formación Digital para Directivos",
          description: "Capacitamos a directivos y líderes empresariales en las últimas tendencias digitales y tecnológicas.",
          price: "Desde 150 €/hora"
        },
        {
          title: "Digitalización para PYMES",
          description: "Ayudamos a las pequeñas y medianas empresas a digitalizar sus procesos y competir en el mercado digital.",
          price: "Desde 3.500 €"
        }
      ],
      inquire: "Consultar →",
      custom: {
        title: "¿Necesitas algo personalizado?",
        subtitle: "Cada proyecto es único. Contáctanos para discutir tus necesidades específicas y obtener una propuesta personalizada.",
        cta: "Solicitar Presupuesto Personalizado"
      },
      // Desarrollo Web
      webDevelopment: {
        title: "Desarrollo Web",
        subtitle: "Creamos sitios web modernos, responsivos y optimizados para SEO que convierten visitantes en clientes.",
        features: {
          title: "Características Principales",
          responsive: "Diseño responsivo para todos los dispositivos",
          seo: "Optimización SEO para mejor posicionamiento",
          performance: "Alto rendimiento y velocidad de carga",
          security: "Seguridad avanzada y protección de datos",
          maintenance: "Mantenimiento y soporte continuo"
        },
        technologies: {
          title: "Tecnologías"
        },
        process: {
          title: "Nuestro Proceso",
          planning: "Planificación y Análisis",
          planningDesc: "Analizamos tus necesidades y objetivos para crear la estrategia perfecta",
          design: "Diseño UX/UI",
          designDesc: "Creamos diseños atractivos y funcionales centrados en la experiencia del usuario",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos tu sitio web con las mejores prácticas y tecnologías modernas",
          testing: "Pruebas y Optimización",
          testingDesc: "Realizamos pruebas exhaustivas para garantizar calidad y rendimiento",
          launch: "Lanzamiento y Soporte",
          launchDesc: "Lanzamos tu sitio web y proporcionamos soporte continuo"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según las necesidades de tu proyecto",
          consult: "Consultar Precio"
        }
      },
      // Aplicaciones Móviles
      mobileApps: {
        title: "Aplicaciones Móviles",
        subtitle: "Desarrollamos apps nativas e híbridas para iOS y Android con las mejores prácticas de UX/UI.",
        features: {
          title: "Características Principales",
          native: "Desarrollo nativo para iOS y Android",
          hybrid: "Aplicaciones híbridas multiplataforma",
          ux: "Diseño UX/UI centrado en el usuario",
          performance: "Alto rendimiento y optimización",
          maintenance: "Mantenimiento y actualizaciones"
        },
        platforms: {
          title: "Plataformas"
        },
        process: {
          title: "Nuestro Proceso",
          analysis: "Análisis de Requisitos",
          analysisDesc: "Analizamos tus necesidades y definimos la funcionalidad de la app",
          design: "Diseño y Prototipado",
          designDesc: "Creamos wireframes y prototipos interactivos",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos la aplicación con las mejores prácticas",
          testing: "Pruebas y QA",
          testingDesc: "Realizamos pruebas exhaustivas en múltiples dispositivos",
          deployment: "Despliegue y Publicación",
          deploymentDesc: "Publicamos en App Store y Google Play"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de la aplicación",
          consult: "Consultar Precio"
        }
      },
      // Consultoría IT
      itConsulting: {
        title: "Consultoría IT",
        subtitle: "Asesoramiento estratégico para optimizar procesos tecnológicos y mejorar la eficiencia operativa.",
        services: {
          title: "Servicios de Consultoría",
          strategy: "Estrategia tecnológica y roadmap digital",
          optimization: "Optimización de procesos y sistemas",
          architecture: "Arquitectura de software y sistemas",
          security: "Seguridad informática y compliance",
          transformation: "Transformación digital empresarial"
        },
        technologies: {
          title: "Tecnologías ofertadas"
        },
        methodology: {
          title: "Nuestra Metodología",
          assessment: "Evaluación Inicial",
          assessmentDesc: "Analizamos tu infraestructura y procesos actuales",
          planning: "Planificación Estratégica",
          planningDesc: "Desarrollamos un plan de acción personalizado",
          implementation: "Implementación",
          implementationDesc: "Ejecutamos las mejoras y optimizaciones",
          monitoring: "Monitoreo y Seguimiento",
          monitoringDesc: "Supervisamos el rendimiento y resultados",
          optimization: "Optimización Continua",
          optimizationDesc: "Mejoramos constantemente basándonos en datos"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Consultoría por horas con tarifas flexibles",
          consult: "Consultar Tarifa"
        }
      },
      // Cloud & DevOps
      cloudDevOps: {
        title: "Cloud & DevOps",
        subtitle: "Implementamos infraestructuras cloud escalables y automatizamos procesos de desarrollo y despliegue.",
        services: {
          title: "Servicios Cloud & DevOps",
          infrastructure: "Infraestructura cloud escalable",
          automation: "Automatización de CI/CD",
          monitoring: "Monitoreo y alertas 24/7",
          security: "Seguridad y compliance cloud",
          scalability: "Escalabilidad automática"
        },
        platforms: {
          title: "Plataformas Cloud"
        },
        process: {
          title: "Nuestro Proceso",
          assessment: "Evaluación de Infraestructura",
          assessmentDesc: "Analizamos tu infraestructura actual y necesidades",
          architecture: "Diseño de Arquitectura",
          architectureDesc: "Diseñamos la arquitectura cloud óptima",
          implementation: "Implementación",
          implementationDesc: "Desplegamos la infraestructura cloud",
          automation: "Automatización",
          automationDesc: "Configuramos pipelines de CI/CD",
          optimization: "Optimización Continua",
          optimizationDesc: "Optimizamos costos y rendimiento"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de la infraestructura",
          consult: "Consultar Precio"
        }
      },
      // Inteligencia Artificial
      artificialIntelligence: {
        title: "Inteligencia Artificial",
        subtitle: "Desarrollamos soluciones de IA y machine learning para automatizar procesos y extraer insights valiosos.",
        solutions: {
          title: "Soluciones de IA",
          automation: "Automatización de procesos",
          analytics: "Análisis predictivo avanzado",
          prediction: "Modelos de predicción",
          nlp: "Procesamiento de lenguaje natural",
          computerVision: "Visión por computadora"
        },
        technologies: {
          title: "Tecnologías de IA"
        },
        process: {
          title: "Nuestro Proceso",
          dataCollection: "Recopilación de Datos",
          dataCollectionDesc: "Recopilamos y preparamos los datos necesarios",
          preprocessing: "Preprocesamiento",
          preprocessingDesc: "Limpiamos y preparamos los datos para el modelo",
          modeling: "Modelado",
          modelingDesc: "Desarrollamos y seleccionamos el mejor modelo",
          training: "Entrenamiento",
          trainingDesc: "Entrenamos el modelo con datos históricos",
          deployment: "Despliegue",
          deploymentDesc: "Implementamos el modelo en producción"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad del proyecto de IA",
          consult: "Consultar Precio"
        }
      },
      // Ciberseguridad
      cybersecurity: {
        title: "Ciberseguridad",
        subtitle: "Protegemos tu infraestructura digital con servicios avanzados de seguridad informática y auditorías de vulnerabilidades.",
        services: {
          title: "Servicios de Ciberseguridad",
          penetrationTesting: "Pruebas de penetración",
          vulnerabilityAssessment: "Evaluación de vulnerabilidades",
          securityAudit: "Auditoría de seguridad",
          incidentResponse: "Respuesta a incidentes",
          compliance: "Cumplimiento normativo"
        },
        tools: {
          title: "Herramientas de Seguridad"
        },
        process: {
          title: "Nuestro Proceso",
          reconnaissance: "Reconocimiento",
          reconnaissanceDesc: "Recopilamos información sobre la infraestructura objetivo",
          scanning: "Escaneo",
          scanningDesc: "Identificamos puertos abiertos y servicios vulnerables",
          analysis: "Análisis",
          analysisDesc: "Analizamos las vulnerabilidades encontradas",
          reporting: "Reporte",
          reportingDesc: "Generamos un informe detallado con recomendaciones",
          remediation: "Remediación",
          remediationDesc: "Ayudamos a corregir las vulnerabilidades identificadas"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según el alcance de la auditoría de seguridad",
          consult: "Consultar Precio"
        }
      },
      // E-commerce
      ecommerce: {
        title: "E-commerce",
        subtitle: "Creamos tiendas online completas y funcionales que convierten visitantes en clientes y maximizan tus ventas.",
        features: {
          title: "Características Principales",
          catalog: "Catálogo de productos avanzado",
          payment: "Integración de pasarelas de pago",
          inventory: "Gestión de inventario en tiempo real",
          analytics: "Analytics y reportes de ventas",
          mobile: "Experiencia móvil optimizada"
        },
        platforms: {
          title: "Plataformas E-commerce"
        },
        process: {
          title: "Nuestro Proceso",
          planning: "Planificación y Análisis",
          planningDesc: "Analizamos tu negocio y definimos la estrategia de e-commerce",
          design: "Diseño UX/UI",
          designDesc: "Creamos una experiencia de compra atractiva y funcional",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos la tienda con las mejores tecnologías",
          integration: "Integración de Sistemas",
          integrationDesc: "Conectamos con pasarelas de pago y sistemas de gestión",
          launch: "Lanzamiento y Optimización",
          launchDesc: "Lanzamos la tienda y optimizamos para conversiones"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de la tienda online",
          consult: "Consultar Precio"
        }
      },
      // Marketing en Redes Sociales
      socialMedia: {
        title: "Marketing en RRSS",
        subtitle: "Gestionamos tu presencia en redes sociales para aumentar tu visibilidad y engagement con tu audiencia.",
        services: {
          title: "Servicios de Marketing Digital",
          strategy: "Estrategia de redes sociales",
          content: "Creación de contenido atractivo",
          ads: "Publicidad pagada en redes",
          community: "Gestión de comunidad",
          analytics: "Análisis y reportes"
        },
        platforms: {
          title: "Plataformas Sociales"
        },
        process: {
          title: "Nuestro Proceso",
          audit: "Auditoría de Redes Sociales",
          auditDesc: "Analizamos tu presencia actual en redes sociales",
          strategy: "Desarrollo de Estrategia",
          strategyDesc: "Creamos una estrategia personalizada para tu marca",
          content: "Creación de Contenido",
          contentDesc: "Desarrollamos contenido atractivo y relevante",
          management: "Gestión Diaria",
          managementDesc: "Gestionamos tus redes sociales de forma profesional",
          optimization: "Optimización Continua",
          optimizationDesc: "Mejoramos constantemente basándonos en resultados"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Planes mensuales personalizados según tus necesidades",
          consult: "Consultar Plan"
        }
      },
      // Automatización de Procesos
      automation: {
        title: "Automatización de Procesos",
        subtitle: "Automatizamos procesos repetitivos para mejorar la eficiencia operativa y reducir costos de tu empresa.",
        features: {
          title: "Características Principales",
          rpa: "Automatización robótica de procesos (RPA)",
          workflow: "Automatización de flujos de trabajo",
          integration: "Integración con sistemas existentes",
          monitoring: "Monitoreo y reportes en tiempo real",
          scalability: "Escalabilidad y flexibilidad"
        },
        technologies: {
          title: "Tecnologías"
        },
        process: {
          title: "Nuestro Proceso",
          analysis: "Análisis de Procesos",
          analysisDesc: "Identificamos procesos candidatos para automatización",
          design: "Diseño de Solución",
          designDesc: "Diseñamos la arquitectura de automatización óptima",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos los bots y flujos automatizados",
          testing: "Pruebas y Validación",
          testingDesc: "Probamos exhaustivamente en entornos controlados",
          deployment: "Despliegue y Monitoreo",
          deploymentDesc: "Implementamos y monitoreamos el rendimiento"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de los procesos",
          consult: "Consultar Precio"
        }
      },
      // Marketing Corporativo
      corporateMarketing: {
        title: "Marketing Corporativo",
        subtitle: "Desarrollamos estrategias de marketing B2B y corporativo para posicionar tu empresa en el mercado empresarial.",
        services: {
          title: "Servicios de Marketing B2B",
          branding: "Branding corporativo y posicionamiento",
          strategy: "Estrategias de marketing B2B",
          content: "Content marketing y thought leadership",
          digital: "Marketing digital para empresas",
          analytics: "Análisis y métricas B2B"
        },
        channels: {
          title: "Canales Corporativos"
        },
        process: {
          title: "Nuestro Proceso",
          audit: "Auditoría de Marca",
          auditDesc: "Analizamos tu posicionamiento actual en el mercado B2B",
          strategy: "Desarrollo de Estrategia",
          strategyDesc: "Creamos una estrategia de marketing corporativo personalizada",
          implementation: "Implementación",
          implementationDesc: "Ejecutamos campañas y estrategias de marketing B2B",
          optimization: "Optimización Continua",
          optimizationDesc: "Mejoramos constantemente basándonos en métricas y resultados"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Planes personalizados según el tamaño y sector de tu empresa",
          consult: "Consultar Plan"
        }
      },
      // Formación Digital para Directivos
      digitalTraining: {
        title: "Formación Digital para Directivos",
        subtitle: "Capacitamos a directivos y líderes empresariales en las últimas tendencias digitales y tecnológicas.",
        programs: {
          title: "Programas de Formación",
          strategy: "Estrategia digital empresarial",
          transformation: "Transformación digital",
          innovation: "Innovación tecnológica",
          leadership: "Liderazgo digital",
          analytics: "Analytics para directivos"
        },
        methodologies: {
          title: "Metodologías"
        },
        process: {
          title: "Nuestro Proceso",
          assessment: "Evaluación de Necesidades",
          assessmentDesc: "Analizamos las necesidades formativas específicas de tu equipo directivo",
          customization: "Personalización",
          customizationDesc: "Adaptamos el programa a tu industria y objetivos empresariales",
          implementation: "Implementación",
          implementationDesc: "Ejecutamos sesiones formativas con metodologías prácticas",
          followup: "Seguimiento y Soporte",
          followupDesc: "Proporcionamos seguimiento continuo y soporte post-formación"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Programas personalizados según el número de participantes y duración",
          consult: "Consultar Programa"
        }
      },
      // Digitalización para PYMES
      smeDigitalization: {
        title: "Digitalización para PYMES",
        subtitle: "Ayudamos a las pequeñas y medianas empresas a digitalizar sus procesos y competir en el mercado digital.",
        solutions: {
          title: "Soluciones Digitales",
          erp: "Sistemas ERP adaptados a PYMES",
          crm: "Gestión de clientes y CRM",
          ecommerce: "Comercio electrónico y tiendas online",
          automation: "Automatización de procesos",
          cloud: "Migración a la nube"
        },
        benefits: {
          title: "Beneficios"
        },
        process: {
          title: "Nuestro Proceso",
          diagnosis: "Diagnóstico Digital",
          diagnosisDesc: "Evaluamos el estado actual de digitalización de tu PYME",
          planning: "Planificación Estratégica",
          planningDesc: "Desarrollamos un roadmap de digitalización personalizado",
          implementation: "Implementación Gradual",
          implementationDesc: "Implementamos soluciones digitales de forma progresiva",
          support: "Soporte Continuo",
          supportDesc: "Proporcionamos soporte técnico y formación continua"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Soluciones escalables según el tamaño y necesidades de tu PYME",
          consult: "Consultar Solución"
        }
      },
      // Análisis de Datos y Business Intelligence
      dataAnalytics: {
        title: "Análisis de Datos y BI",
        subtitle: "Transformamos datos en insights valiosos para la toma de decisiones estratégicas de tu negocio.",
        services: {
          title: "Servicios de Análisis",
          dataWarehouse: "Construcción de data warehouses",
          dashboards: "Dashboards interactivos y reportes",
          reporting: "Reportes automatizados y KPI",
          predictive: "Análisis predictivo y forecasting",
          dataIntegration: "Integración y limpieza de datos"
        },
        tools: {
          title: "Herramientas BI"
        },
        process: {
          title: "Nuestro Proceso",
          assessment: "Evaluación de Datos",
          assessmentDesc: "Analizamos tus fuentes de datos y necesidades de reporting",
          architecture: "Arquitectura de Datos",
          architectureDesc: "Diseñamos la arquitectura de datos óptima para tu negocio",
          development: "Desarrollo",
          developmentDesc: "Construimos data warehouses y dashboards personalizados",
          deployment: "Despliegue y Configuración",
          deploymentDesc: "Implementamos y configuramos las herramientas de BI",
          training: "Capacitación y Soporte",
          trainingDesc: "Entrenamos a tu equipo en el uso de las herramientas"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad del análisis",
          consult: "Consultar Precio"
        }
      },
      // Integración de Sistemas
      systemIntegration: {
        title: "Integración de Sistemas",
        subtitle: "Conectamos tus sistemas empresariales para optimizar flujos de trabajo y mejorar la eficiencia.",
        services: {
          title: "Servicios de Integración",
          apiDevelopment: "Desarrollo de APIs personalizadas",
          dataSync: "Sincronización de datos entre sistemas",
          workflow: "Automatización de flujos de trabajo",
          legacy: "Integración con sistemas legacy",
          monitoring: "Monitoreo y mantenimiento"
        },
        platforms: {
          title: "Plataformas de Integración"
        },
        process: {
          title: "Nuestro Proceso",
          analysis: "Análisis de Sistemas",
          analysisDesc: "Evaluamos tus sistemas actuales y necesidades de integración",
          architecture: "Arquitectura de Integración",
          architectureDesc: "Diseñamos la arquitectura de integración más eficiente",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos las integraciones y APIs necesarias",
          testing: "Pruebas y Validación",
          testingDesc: "Probamos exhaustivamente todas las integraciones",
          deployment: "Despliegue y Monitoreo",
          deploymentDesc: "Implementamos y monitoreamos el rendimiento"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de la integración",
          consult: "Consultar Precio"
        }
      },
      // APIs y Microservicios
      apiMicroservices: {
        title: "APIs y Microservicios",
        subtitle: "Desarrollamos APIs robustas y arquitecturas de microservicios para aplicaciones escalables.",
        services: {
          title: "Servicios de Desarrollo",
          restApis: "Desarrollo de APIs RESTful",
          graphql: "APIs GraphQL modernas",
          microservices: "Arquitectura de microservicios",
          serverless: "Funciones serverless",
          documentation: "Documentación técnica completa"
        },
        technologies: {
          title: "Tecnologías"
        },
        process: {
          title: "Nuestro Proceso",
          planning: "Planificación y Análisis",
          planningDesc: "Analizamos requisitos y diseñamos la arquitectura",
          design: "Diseño de API",
          designDesc: "Diseñamos la estructura y endpoints de la API",
          development: "Desarrollo",
          developmentDesc: "Desarrollamos APIs y microservicios con mejores prácticas",
          testing: "Pruebas y QA",
          testingDesc: "Realizamos pruebas unitarias, integración y carga",
          deployment: "Despliegue y CI/CD",
          deploymentDesc: "Implementamos con pipelines de CI/CD automatizados"
        },
        pricing: {
          title: "Precios",
          startingFrom: "A partir de",
          description: "Precios personalizados según la complejidad de la API",
          consult: "Consultar Precio"
        }
      }
    },

    // Success Cases Section
    successCases: {
      title: "Casos de Éxito",
      subtitle: "Descubre cómo hemos ayudado a nuestros clientes a alcanzar sus objetivos y transformar sus negocios con soluciones tecnológicas innovadoras.",
      cases: [
        {
          title: "E-commerce Multiplataforma",
          client: "TechRetail Solutions",
          description: "Desarrollamos una plataforma de e-commerce completa con integración de múltiples canales de venta, sistema de gestión de inventario y análisis avanzado de datos.",
          results: [
            "Aumento del 300% en ventas online",
            "Reducción del 40% en costos operativos",
            "Mejora del 85% en tiempo de carga"
          ]
        },
        {
          title: "App de Gestión Logística",
          client: "LogiTech Express",
          description: "Creamos una aplicación móvil para optimizar rutas de entrega, seguimiento en tiempo real y gestión de flotas de vehículos.",
          results: [
            "Optimización del 60% en rutas de entrega",
            "Reducción del 25% en costos de combustible",
            "Mejora del 90% en satisfacción del cliente"
          ]
        },
        {
          title: "Sistema de IA para Análisis Predictivo",
          client: "DataInsight Corp",
          description: "Implementamos un sistema de inteligencia artificial para predecir tendencias de mercado y optimizar estrategias de inversión.",
          results: [
            "Precisión del 87% en predicciones",
            "ROI del 450% en el primer año",
            "Automatización del 70% de decisiones"
          ]
        }
      ],
      keyResults: "Resultados Clave:",
      technologies: "Tecnologías Utilizadas:",
      cta: {
        title: "¿Quieres ser nuestro próximo caso de éxito?",
        subtitle: "Únete a la lista de clientes satisfechos que han transformado sus negocios con nuestras soluciones tecnológicas.",
        button: "Comenzar tu Proyecto"
      }
    },

    // Contact Section
    contact: {
      title: "Contáctanos",
      subtitle: "¿Listo para transformar tu negocio? Estamos aquí para ayudarte a hacer realidad tu visión digital.",
      project: {
        title: "Hablemos de tu Proyecto",
        description: "Nuestro equipo de expertos está listo para escuchar tus necesidades y crear una solución personalizada que impulse tu negocio hacia el éxito."
      },
      methods: {
        meeting: {
          title: "Agenda una Reunión",
          description: "Programa una consulta gratuita de 30 minutos para discutir tu proyecto.",
          button: "Reservar Cita"
        },
        email: {
          title: "Envíanos un Email",
          description: "Cuéntanos sobre tu proyecto y te responderemos en menos de 24 horas."
        }
      },
      consultation: {
        title: "¿Qué incluye la consulta gratuita?",
        items: [
          "Análisis de tus necesidades específicas",
          "Propuesta de solución personalizada",
          "Estimación de tiempo y presupuesto",
          "Sin compromiso ni costos ocultos"
        ]
      },
      ready: {
        title: "¿Listo para Comenzar?",
        description: "Nuestro equipo está esperando para ayudarte a hacer realidad tu proyecto. ¡No esperes más para transformar tu visión en realidad!",
        scheduleButton: "Agendar Consulta Gratuita",
        emailButton: "Enviar Email"
      }
    },

    // Footer
    footer: {
      copyright: "© Xperiecia Consulting 2025. All rights reserved.",
      tagline: "Transformando ideas en soluciones digitales innovadoras"
    },

    // Login
    login: {
      title: "Acceso",
      subtitle: "Inicia sesión para acceder a tu área personal",
      email: "Correo electrónico",
      emailPlaceholder: "tu@email.com",
      password: "Contraseña",
      passwordPlaceholder: "Tu contraseña",
      signIn: "Iniciar Sesión",
      signingIn: "Iniciando sesión...",
      backToHome: "Volver al Inicio",
      demoCredentials: "Credenciales de Demostración",
      continueWith: "o continúa con",
      connectWithGoogle: "Conectando con Google...",
      signInWithGoogle: "Iniciar sesión con Google",
      googleError: "Error al iniciar sesión con Google. Intenta nuevamente.",
      credentialsError: "Credenciales incorrectas. Por favor, verifica tu email y contraseña.",
      accountCreatedSuccess: "¡Cuenta creada y sesión iniciada con Google!",
      signInSuccess: "¡Sesión iniciada con Google!",
      demoEmailAdmin: "Email Admin:",
      demoEmailClient: "Email Cliente:",
      demoPassword: "Password:",
      noAccount: "¿No tienes cuenta?",
      createAccount: "Crear cuenta",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      signInHere: "Inicia sesión aquí"
    },

    // Register
    register: {
      title: "Registrarse",
      subtitle: "Crea tu cuenta para acceder a nuestros servicios",
      name: "Nombre completo",
      namePlaceholder: "Tu nombre completo",
      email: "Email",
      emailPlaceholder: "tu@email.com",
      company: "Empresa (opcional)",
      companyPlaceholder: "Nombre de tu empresa",
      phone: "Teléfono (opcional)",
      phonePlaceholder: "+1234567890",
      password: "Contraseña",
      passwordPlaceholder: "Mínimo 6 caracteres",
      confirmPassword: "Confirmar contraseña",
      confirmPasswordPlaceholder: "Repite tu contraseña",
      createAccount: "Crear cuenta",
      creatingAccount: "Creando cuenta...",
      registerWithGoogle: "Registrarse con Google",
      connectingWithGoogle: "Conectando con Google...",
      termsText: "Al registrarte, aceptas nuestros términos y condiciones. Tu información será utilizada únicamente para gestionar tus solicitudes de presupuestos y proyectos.",
      orRegisterWith: "o regístrate con",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      signInHere: "Inicia sesión",
      successMessage: "¡Registro exitoso! Ya puedes iniciar sesión.",
      errorMessage: "Error al registrar usuario",
      emailExistsError: "Este email ya está registrado",
      invalidDataError: "Datos inválidos. Verifica la información",
      serverError: "Error del servidor. Intenta más tarde",
      googleError: "Error al registrarse con Google. Intenta nuevamente.",
      googleConnectError: "Error al conectar con Google. Intenta nuevamente.",
      accountCreatedSuccess: "¡Cuenta creada y sesión iniciada con Google!",
      signInSuccess: "¡Sesión iniciada con Google!"
    },

    // Dashboard
    dashboard: {
      title: "Panel de Administración",
      subtitle: "Gestiona proyectos, clientes y recursos de la empresa",
      welcome: "Bienvenido",
      backToHome: "Volver al Inicio",
      logout: "Cerrar Sesión",
      stats: {
        activeProjects: "Proyectos Activos",
        totalClients: "Total Clientes",
        monthlyRevenue: "Ingresos Mensuales"
      }
    },

    // Project Management
    projectManagement: {
      title: "Gestión de Proyectos",
      subtitle: "Administra y supervisa todos los proyectos activos",
      newProject: "Nuevo Proyecto",
      backToDashboard: "Volver al Dashboard",
      stats: {
        totalProjects: "Total Proyectos",
        inProgress: "En Progreso",
        completed: "Completados",
        totalBudget: "Presupuesto Total",
        totalSpent: "Gastado Total"
      },
      filters: {
        searchPlaceholder: "Buscar proyectos...",
        allStatuses: "Todos los estados",
        planning: "Planificación",
        inProgress: "En Progreso",
        inReview: "En Revisión",
        completed: "Completado",
        cancelled: "Cancelado"
      },
      table: {
        project: "Proyecto",
        client: "Cliente",
        status: "Estado",
        progress: "Progreso",
        budget: "Presupuesto",
        priority: "Prioridad",
        actions: "Acciones"
      },
      priorities: {
        low: "Baja",
        medium: "Media",
        high: "Alta",
        critical: "Crítica"
      },
      modal: {
        newProject: "Nuevo Proyecto",
        editProject: "Editar Proyecto",
        projectName: "Nombre del Proyecto",
        client: "Cliente",
        status: "Estado",
        startDate: "Fecha de Inicio",
        endDate: "Fecha de Fin",
        budget: "Presupuesto (€)",
        priority: "Prioridad",
        description: "Descripción",
        cancel: "Cancelar",
        createProject: "Crear Proyecto",
        saveChanges: "Guardar Cambios",
        deleteConfirm: "¿Estás seguro de que quieres eliminar este proyecto?"
      },
      jira: {
        title: "Integración con Jira",
        configure: "Configurar Jira",
        viewJira: "Ver Jira",
        disconnect: "Desconectar Jira",
        configModal: {
          title: "Configurar Integración con Jira",
          url: "URL de Jira",
          urlPlaceholder: "https://tuempresa.atlassian.net",
          email: "Email",
          emailPlaceholder: "tu-email@empresa.com",
          apiToken: "API Token",
          apiTokenPlaceholder: "Tu API token de Jira",
          projectKey: "Clave del Proyecto",
          projectKeyPlaceholder: "PROJ",
          boardId: "ID del Tablero",
          boardIdPlaceholder: "123",
          infoTitle: "Información importante",
          infoText: "Para obtener tu API token de Jira:",
          infoSteps: [
            "Ve a https://id.atlassian.com/manage-profile/security/api-tokens",
            "Crea un nuevo token",
            "Copia el token y pégalo aquí"
          ],
          saveConfig: "Guardar Configuración",
          cancel: "Cancelar"
        },
        viewModal: {
          title: "Jira - {projectName}",
          lastSync: "Última sincronización: {date}",
          openInJira: "Abrir en Jira",
          close: "Cerrar",
          metrics: {
            totalIssues: "Issues Totales",
            activeSprints: "Sprints Activos",
            currentVelocity: "Velocidad Actual",
            pendingIssues: "Issues Pendientes"
          },
          issues: {
            title: "Issues Recientes",
            issue: "Issue",
            summary: "Resumen",
            status: "Estado",
            assignee: "Asignado",
            priority: "Prioridad",
            type: "Tipo",
            statuses: {
              done: "Done",
              inProgress: "In Progress",
              toDo: "To Do"
            },
            priorities: {
              high: "High",
              medium: "Medium",
              low: "Low"
            },
            types: {
              story: "Story",
              bug: "Bug",
              task: "Task"
            }
          },
          sprints: {
            title: "Sprints",
            startDate: "Inicio",
            endDate: "Fin",
            completed: "Completadas",
            progress: "Progreso",
            states: {
              active: "Activo",
              future: "Futuro",
              completed: "Completado"
            }
          }
        },
        disconnectConfirm: "¿Estás seguro de que quieres desconectar la integración con Jira?"
      }
    },

    // Client Management
    clientManagement: {
      title: "Gestión de Clientes",
      subtitle: "Administra la base de datos de clientes y prospectos",
      newClient: "Nuevo Cliente",
      backToDashboard: "Volver al Dashboard",
      stats: {
        totalClients: "Total Clientes",
        activeClients: "Clientes Activos",
        prospects: "Prospectos",
        inactiveClients: "Clientes Inactivos",
        totalRevenue: "Ingresos Totales",
        totalProjects: "Total Proyectos"
      },
      filters: {
        searchPlaceholder: "Buscar clientes...",
        allStatuses: "Todos los estados",
        allIndustries: "Todas las industrias"
      },
      statuses: {
        active: "Activo",
        prospect: "Prospecto",
        inactive: "Inactivo",
        suspended: "Suspendido"
      },
      table: {
        client: "Cliente",
        contact: "Contacto",
        industry: "Industria",
        status: "Estado",
        projects: "Proyectos",
        revenue: "Ingresos",
        lastContact: "Último Contacto",
        actions: "Acciones"
      },
      modal: {
        newClient: "Nuevo Cliente",
        editClient: "Editar Cliente",
        clientName: "Nombre del Cliente",
        contactPerson: "Persona de Contacto",
        email: "Email",
        phone: "Teléfono",
        company: "Empresa",
        industry: "Industria",
        status: "Estado",
        address: "Dirección",
        website: "Sitio Web",
        notes: "Notas",
        cancel: "Cancelar",
        createClient: "Crear Cliente",
        saveChanges: "Guardar Cambios",
        deleteConfirm: "¿Estás seguro de que quieres eliminar este cliente?"
      }
    },

    // Reports & Analytics
    reportsAnalytics: {
      title: "Reportes y Analytics",
      subtitle: "Visualiza métricas clave, tendencias y actividad de la consultora",
      monthlyRevenue: "Ingresos Mensuales",
      activeProjects: "Proyectos Activos",
      newClients: "Clientes Nuevos",
      supportTickets: "Tickets Soporte",
      dateRanges: {
        last12Months: "Últimos 12 meses",
        last6Months: "Últimos 6 meses",
        last3Months: "Últimos 3 meses",
        lastMonth: "Último mes"
      },
      serviceFilters: {
        allServices: "Todos los servicios"
      },
      charts: {
        monthlyRevenue: "Ingresos Mensuales",
        projectsByService: "Proyectos por Servicio",
        projectsAndClients: "Proyectos y Clientes por Mes",
        topClients: "Top Clientes por Ingresos"
      },
      table: {
        client: "Cliente",
        projects: "Proyectos",
        revenue: "Ingresos"
      },
      months: {
        jan: "Ene",
        feb: "Feb",
        mar: "Mar",
        apr: "Abr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Ago",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dic"
      }
    },

    // WhatsApp Button
    whatsapp: {
      tooltip: "¡Chatea con nosotros!"
    },

    // Client Portal
    client: {
      portal: "Portal",
      menu: "Menú",
      logout: "Cerrar Sesión",
      dashboard: "Dashboard",
      budgets: "Presupuestos",
      services: "Servicios",
      projects: "Proyectos",
      support: "Soporte",
      analytics: "Analíticas",
      profile: "Perfil",
      delivered: "Entregado",
      ready: "Listo",
      userTraining: "Formación de Usuario",
      open: "Abierto",
      
      // Dashboard
      welcomeBack: "Bienvenido de vuelta",
      clientName: "Juan Carlos",
      dashboardSubtitle: "Aquí tienes un resumen de tus proyectos y servicios activos",
      activeBudgets: "Presupuestos Activos",
      activeServices: "Servicios Activos",
      activeProjects: "Proyectos Activos",
      openTickets: "Tickets Abiertos",
      fromLastMonth: "vs mes anterior",
      recentBudgets: "Presupuestos Recientes",
      activeProjectsTitle: "Proyectos Activos",
      viewAll: "Ver Todos",
      websiteRedesign: "Rediseño de Web",
      mobileApp: "App Móvil",
      cloudMigration: "Migración Cloud",
      ecommercePlatform: "Plataforma E-commerce",
      crmIntegration: "Integración CRM",
      progress: "Progreso",
      dueDate: "Fecha de Entrega",
      quickActions: "Acciones Rápidas",
      requestBudget: "Solicitar Presupuesto",
      createTicket: "Crear Ticket",
      requestService: "Solicitar Servicio",
      viewInvoices: "Ver Facturas",
      
      // Budgets
      budgetsSubtitle: "Gestiona y revisa todos tus presupuestos",
      requestBudgetAction: "Solicitar Presupuesto",
      searchBudgets: "Buscar presupuestos...",
      allStatuses: "Todos los estados",
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
      expired: "Expirado",
      sortBy: "Ordenar por",
      date: "Fecha",
      amount: "Importe",
      status: "Estado",
      title: "Título",
      budgetsList: "Lista de Presupuestos",
      websiteRedesignDesc: "Rediseño completo del sitio web corporativo",
      mobileAppDesc: "Desarrollo de aplicación móvil nativa",
      cloudMigrationDesc: "Migración de infraestructura a la nube",
      crmIntegrationDesc: "Integración de sistema CRM",
      design: "Diseño",
      development: "Desarrollo",
      testing: "Testing",
      uiDesign: "Diseño UI",
      appDevelopment: "Desarrollo App",
      backend: "Backend",
      assessment: "Evaluación",
      migration: "Migración",
      analysis: "Análisis",
      integration: "Integración",
      training: "Formación",
      budgetBreakdown: "Desglose del Presupuesto",
      total: "Total",
      created: "Creado",
      validUntil: "Válido hasta",
      view: "Ver",
      download: "Descargar",
      approve: "Aprobar",
      reject: "Rechazar",
      noBudgetsFound: "No se encontraron presupuestos",
      tryAdjustingFilters: "Intenta ajustar los filtros",
      
      // Services
      servicesSubtitle: "Historial de servicios prestados y facturación",
      viewInvoicesAction: "Ver Facturas",
      requestServiceAction: "Solicitar Servicio",
      totalServices: "Total Servicios",
      completed: "Completado",
      inProgress: "En Progreso",
      scheduled: "Programado",
      cancelled: "Cancelado",
      searchServices: "Buscar servicios...",
      servicesList: "Lista de Servicios",
      webDevelopment: "Desarrollo Web",
      webDevelopmentDesc: "Desarrollo de sitio web corporativo",
      mobileAppDevelopment: "Desarrollo App Móvil",
      mobileAppDevelopmentDesc: "Desarrollo de aplicación móvil nativa",
      cloudConsulting: "Consultoría Cloud",
      cloudConsultingDesc: "Asesoramiento en migración cloud",
      securityAudit: "Auditoría de Seguridad",
      securityAuditDesc: "Auditoría completa de seguridad",
      websiteCode: "Código del Sitio Web",
      documentation: "Documentación",
      trainingService: "Formación",
      appCode: "Código de la App",
      apiDocumentation: "Documentación API",
      assessmentReport: "Informe de Evaluación",
      migrationPlan: "Plan de Migración",
      recommendations: "Recomendaciones",
      securityReport: "Informe de Seguridad",
      implementationGuide: "Guía de Implementación",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      deliverables: "Entregables",
      invoice: "Factura",
      paid: "Pagado",
      overdue: "Vencido",
      viewDetails: "Ver Detalles",
      downloadInvoice: "Descargar Factura",
      downloadDeliverables: "Descargar Entregables",
      noServicesFound: "No se encontraron servicios",
      
      // Projects
      projectsSubtitle: "Seguimiento de proyectos en curso y entregables",
      projectTimeline: "Timeline",
      newProject: "Nuevo Proyecto",
      totalProjects: "Total Proyectos",
      teamMembers: "Miembros del Equipo",
      searchProjects: "Buscar proyectos...",
      projectsList: "Lista de Proyectos",
      ecommercePlatformDesc: "Desarrollo de plataforma de comercio electrónico",
      crmIntegrationDescProject: "Integración de sistema CRM",
      mobileAppDescProject: "Desarrollo de aplicación móvil",
      projectManager: "Project Manager",
      frontendDeveloper: "Desarrollador Frontend",
      backendDeveloper: "Desarrollador Backend",
      technicalLead: "Technical Lead",
      integrationSpecialist: "Especialista en Integración",
      mobileDeveloper: "Desarrollador Móvil",
      uiDesigner: "Diseñador UI",
      projectTeam: "Equipo del Proyecto",
      tasks: "Tareas",
      designSystem: "Sistema de Diseño",
      frontendDevelopment: "Desarrollo Frontend",
      backendAPI: "API Backend",
      requirementsAnalysis: "Análisis de Requisitos",
      apiDevelopment: "Desarrollo API",
      dataMigration: "Migración de Datos",
      uiDesignProject: "Diseño UI",
      appDevelopmentProject: "Desarrollo App",
      appStoreSubmission: "Envío App Store",
      websiteCodeProject: "Código del Sitio Web",
      spent: "Gastado",
      remaining: "Restante",
      projectTeam: "Equipo del Proyecto",
      tasks: "Tareas",
      deliverables: "Entregables",
      viewDetails: "Ver Detalles",
      downloadReport: "Descargar Reporte",
      noProjectsFound: "No se encontraron proyectos",
      planning: "Planificación",
      onHold: "En Pausa",
      progressStatus: "Progreso",
      totalTickets: "Total Tickets",
      
      // Support
      supportSubtitle: "Gestiona incidencias y solicita soporte técnico",
      createTicketSupport: "Crear Ticket",
      openTicketsSupport: "Tickets Abiertos",
      inProgressSupport: "En Progreso",
      resolved: "Resuelto",
      closed: "Cerrado",
      allPriorities: "Todas las prioridades",
      low: "Baja",
      medium: "Media",
      high: "Alta",
      urgent: "Urgente",
      liveChat: "Chat en Vivo",
      searchTickets: "Buscar tickets...",
      ticketsList: "Lista de Tickets",
      loginIssue: "Problema de Acceso",
      loginIssueDesc: "No puedo acceder a mi cuenta",
      featureRequest: "Solicitud de Función",
      featureRequestDesc: "Solicito nueva funcionalidad",
      billingQuestion: "Consulta de Facturación",
      billingQuestionDesc: "Duda sobre factura reciente",
      performanceIssue: "Problema de Rendimiento",
      performanceIssueDesc: "La aplicación va lenta",
      technical: "Técnico",
      feature: "Funcionalidad",
      billing: "Facturación",
      assignedTo: "Asignado a",
      updated: "Actualizado",
      latestMessage: "Último Mensaje",
      loginIssueMessage: "No puedo acceder a mi cuenta desde ayer",
      loginIssueResponse: "Hemos verificado tu cuenta. Intenta acceder ahora",
      featureRequestMessage: "Me gustaría solicitar una nueva función",
      featureRequestResponse: "Hemos registrado tu solicitud. Te contactaremos pronto",
      billingQuestionMessage: "Tengo una duda sobre la factura del mes pasado",
      billingQuestionResponse: "Te hemos enviado un email con la explicación detallada",
      performanceIssueMessage: "La aplicación va muy lenta últimamente",
      reply: "Responder",
      reopen: "Reabrir",
      noTicketsFound: "No se encontraron tickets",
      createNewTicket: "Crear Nuevo Ticket",
      subject: "Asunto",
      ticketSubject: "Asunto del ticket",
      description: "Descripción",
      ticketDescription: "Describe tu problema o solicitud",
      priority: "Prioridad",
      cancel: "Cancelar",
      
      // Analytics
      analyticsSubtitle: "Analíticas y reportes de tus proyectos y servicios",
      lastWeek: "Última Semana",
      lastMonth: "Último Mes",
      lastQuarter: "Último Trimestre",
      lastYear: "Último Año",
      exportReport: "Exportar Reporte",
      totalSpent: "Total Gastado",
      activeProjectsAnalytics: "Proyectos Activos",
      avgResponseTime: "Tiempo Respuesta Promedio",
      openTicketsAnalytics: "Tickets Abiertos",
      fromLastPeriod: "vs período anterior",
      monthlySpending: "Gasto Mensual",
      serviceBreakdown: "Desglose de Servicios",
      webDevelopmentAnalytics: "Desarrollo Web",
      mobileDevelopment: "Desarrollo Móvil",
      consulting: "Consultoría",
      security: "Seguridad",
      projectPerformance: "Rendimiento de Proyectos",
      onTrack: "En Camino",
      delayed: "Retrasado",
      budget: "Presupuesto",
      spent: "Gastado",
      recentActivity: "Actividad Reciente",
      projectStarted: "Proyecto Iniciado",
      crmIntegrationStarted: "Se inició la integración CRM",
      ticketCreated: "Ticket Creado",
      performanceIssueTicket: "Ticket de problema de rendimiento",
      budgetApproved: "Presupuesto Aprobado",
      crmIntegrationBudget: "Presupuesto de integración CRM aprobado",
      serviceCompleted: "Servicio Completado",
      mobileAppCompleted: "Aplicación móvil completada",
      
      // Profile
      profileSubtitle: "Gestiona tu perfil y configuración de cuenta",
      edit: "Editar",
      save: "Guardar",
      fullName: "Nombre Completo",
      email: "Email",
      phone: "Teléfono",
      company: "Empresa",
      position: "Cargo",
      website: "Sitio Web",
      address: "Dirección",
      industry: "Industria",
      companySize: "Tamaño de Empresa",
      joinDate: "Fecha de Registro",
      preferences: "Preferencias",
      language: "Idioma",
      timezone: "Zona Horaria",
      currency: "Moneda",
      securityProfile: "Seguridad",
      twoFactorAuth: "Autenticación de Dos Factores",
      twoFactorAuthDesc: "Añade una capa extra de seguridad a tu cuenta",
      enabled: "Habilitado",
      disabled: "Deshabilitado",
      enable: "Habilitar",
      disable: "Deshabilitar",
      lastPasswordChange: "Último Cambio de Contraseña",
      lastLogin: "Último Acceso",
      loginHistory: "Historial de Accesos",
      notifications: "Notificaciones",
      emailAddress: "Email",
      sms: "SMS",
      push: "Push",
      projectUpdates: "Actualizaciones de Proyectos",
      budgetAlerts: "Alertas de Presupuesto",
      supportUpdates: "Actualizaciones de Soporte",
      emailDesc: "Recibe notificaciones por email",
      smsDesc: "Recibe notificaciones por SMS",
      pushDesc: "Recibe notificaciones push",
      projectUpdatesDesc: "Actualizaciones sobre el progreso de proyectos",
      budgetAlertsDesc: "Alertas cuando se alcance el presupuesto",
      supportUpdatesDesc: "Actualizaciones sobre tickets de soporte"
    }
  },

  en: {
    // Navbar
    nav: {
      home: "Home",
      services: "Services",
      successCases: "Success Cases",
      contact: "Contact",
      back: "Back"
    },

    // Home Section
    home: {
      hero: {
        title: "We Transform Your",
        titleHighlight: "Digital Vision",
        subtitle: "We are an IT consulting firm specialized in creating innovative technological solutions that drive your business growth."
      },
      stats: {
        projects: "Completed Projects",
        clients: "Satisfied Clients",
        experience: "Years of Experience"
      },
      cta: {
        startProject: "Start Project",
        viewServices: "View Services",
        registerNow: "Register Now",
        learnMore: "Learn More"
      },
      trust: {
        title: "Trusted by:"
      }
    },

    // Services Section
    services: {
      title: "Our Services",
      subtitle: "We offer comprehensive technological solutions to drive your business towards the digital future.",
      services: [
        {
          title: "Web Development",
          description: "We create modern, responsive, and SEO-optimized websites that convert visitors into customers.",
          price: "From €3,500"
        },
        {
          title: "Mobile Applications",
          description: "We develop native and hybrid apps for iOS and Android with best UX/UI practices.",
          price: "From €8,000"
        },
        {
          title: "IT Consulting",
          description: "Strategic advice to optimize technological processes and improve operational efficiency.",
          price: "From €120/hour"
        },
        {
          title: "Cloud & DevOps",
          description: "We implement scalable cloud infrastructures and automate development and deployment processes.",
          price: "From €2,500"
        },
        {
          title: "Artificial Intelligence",
          description: "We develop AI and machine learning solutions to automate processes and extract valuable insights.",
          price: "From €15,000"
        },
        {
          title: "Cybersecurity",
          description: "We protect your digital infrastructure with advanced cybersecurity services and vulnerability audits.",
          price: "From €5,000"
        },
        {
          title: "E-commerce",
          description: "We create complete and functional online stores that convert visitors into customers and maximize your sales.",
          price: "From €6,500"
        },
        {
          title: "Social Media Marketing",
          description: "We manage your social media presence to increase your visibility and engagement with your audience.",
          price: "From €1,200/month"
        },
        {
          title: "Process Automation",
          description: "We automate repetitive processes to improve operational efficiency and reduce your company's costs.",
          price: "From €4,500"
        },
        {
          title: "Data Analytics & BI",
          description: "We transform data into valuable insights for strategic business decision making.",
          price: "From €8,500"
        },
        {
          title: "System Integration",
          description: "We connect your business systems to optimize workflows and improve efficiency.",
          price: "From €7,500"
        },
        {
          title: "APIs & Microservices",
          description: "We develop robust APIs and microservices architectures for scalable applications.",
          price: "From €5,500"
        },
        {
          title: "Corporate Marketing",
          description: "We develop B2B and corporate marketing strategies to position your company in the business market.",
          price: "From €2,500/month"
        },
        {
          title: "Digital Training for Executives",
          description: "We train executives and business leaders in the latest digital and technological trends.",
          price: "From €150/hour"
        },
        {
          title: "SME Digitalization",
          description: "We help small and medium enterprises digitize their processes and compete in the digital market.",
          price: "From €3,500"
        }
      ],
      inquire: "Inquire →",
      custom: {
        title: "Need something custom?",
        subtitle: "Every project is unique. Contact us to discuss your specific needs and get a personalized proposal.",
        cta: "Request Custom Quote"
      },
      // Web Development
      webDevelopment: {
        title: "Web Development",
        subtitle: "We create modern, responsive, and SEO-optimized websites that convert visitors into customers.",
        features: {
          title: "Key Features",
          responsive: "Responsive design for all devices",
          seo: "SEO optimization for better ranking",
          performance: "High performance and loading speed",
          security: "Advanced security and data protection",
          maintenance: "Continuous maintenance and support"
        },
        technologies: {
          title: "Technologies"
        },
        process: {
          title: "Our Process",
          planning: "Planning and Analysis",
          planningDesc: "We analyze your needs and objectives to create the perfect strategy",
          design: "UX/UI Design",
          designDesc: "We create attractive and functional designs focused on user experience",
          development: "Development",
          developmentDesc: "We develop your website with best practices and modern technologies",
          testing: "Testing and Optimization",
          testingDesc: "We perform exhaustive tests to ensure quality and performance",
          launch: "Launch and Support",
          launchDesc: "We launch your website and provide continuous support"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on your project needs",
          consult: "Request Quote"
        }
      },
      // Mobile Applications
      mobileApps: {
        title: "Mobile Applications",
        subtitle: "We develop native and hybrid apps for iOS and Android with best UX/UI practices.",
        features: {
          title: "Key Features",
          native: "Native development for iOS and Android",
          hybrid: "Cross-platform hybrid applications",
          ux: "User-centered UX/UI design",
          performance: "High performance and optimization",
          maintenance: "Maintenance and updates"
        },
        platforms: {
          title: "Platforms"
        },
        process: {
          title: "Our Process",
          analysis: "Requirements Analysis",
          analysisDesc: "We analyze your needs and define app functionality",
          design: "Design and Prototyping",
          designDesc: "We create wireframes and interactive prototypes",
          development: "Development",
          developmentDesc: "We develop the application with best practices",
          testing: "Testing and QA",
          testingDesc: "We perform exhaustive tests on multiple devices",
          deployment: "Deployment and Publication",
          deploymentDesc: "We publish to App Store and Google Play"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on application complexity",
          consult: "Request Quote"
        }
      },
      // IT Consulting
      itConsulting: {
        title: "IT Consulting",
        subtitle: "Strategic advice to optimize technological processes and improve operational efficiency.",
        services: {
          title: "Consulting Services",
          strategy: "Technology strategy and digital roadmap",
          optimization: "Process and system optimization",
          architecture: "Software and system architecture",
          security: "Cybersecurity and compliance",
          transformation: "Business digital transformation"
        },
        technologies: {
          title: "Technologies Offered"
        },
        methodology: {
          title: "Our Methodology",
          assessment: "Initial Assessment",
          assessmentDesc: "We analyze your current infrastructure and processes",
          planning: "Strategic Planning",
          planningDesc: "We develop a personalized action plan",
          implementation: "Implementation",
          implementationDesc: "We execute improvements and optimizations",
          monitoring: "Monitoring and Follow-up",
          monitoringDesc: "We supervise performance and results",
          optimization: "Continuous Optimization",
          optimizationDesc: "We constantly improve based on data"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Hourly consulting with flexible rates",
          consult: "Request Rate"
        }
      },
      // Cloud & DevOps
      cloudDevOps: {
        title: "Cloud & DevOps",
        subtitle: "We implement scalable cloud infrastructures and automate development and deployment processes.",
        services: {
          title: "Cloud & DevOps Services",
          infrastructure: "Scalable cloud infrastructure",
          automation: "CI/CD automation",
          monitoring: "24/7 monitoring and alerts",
          security: "Cloud security and compliance",
          scalability: "Automatic scalability"
        },
        platforms: {
          title: "Cloud Platforms"
        },
        process: {
          title: "Our Process",
          assessment: "Infrastructure Assessment",
          assessmentDesc: "We analyze your current infrastructure and needs",
          architecture: "Architecture Design",
          architectureDesc: "We design the optimal cloud architecture",
          implementation: "Implementation",
          implementationDesc: "We deploy the cloud infrastructure",
          automation: "Automation",
          automationDesc: "We configure CI/CD pipelines",
          optimization: "Continuous Optimization",
          optimizationDesc: "We optimize costs and performance"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on infrastructure complexity",
          consult: "Request Quote"
        }
      },
      // Artificial Intelligence
      artificialIntelligence: {
        title: "Artificial Intelligence",
        subtitle: "We develop AI and machine learning solutions to automate processes and extract valuable insights.",
        solutions: {
          title: "AI Solutions",
          automation: "Process automation",
          analytics: "Advanced predictive analytics",
          prediction: "Prediction models",
          nlp: "Natural language processing",
          computerVision: "Computer vision"
        },
        technologies: {
          title: "AI Technologies"
        },
        process: {
          title: "Our Process",
          dataCollection: "Data Collection",
          dataCollectionDesc: "We collect and prepare the necessary data",
          preprocessing: "Preprocessing",
          preprocessingDesc: "We clean and prepare data for the model",
          modeling: "Modeling",
          modelingDesc: "We develop and select the best model",
          training: "Training",
          trainingDesc: "We train the model with historical data",
          deployment: "Deployment",
          deploymentDesc: "We implement the model in production"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on AI project complexity",
          consult: "Request Quote"
        }
      },
      // Cybersecurity
      cybersecurity: {
        title: "Cybersecurity",
        subtitle: "We protect your digital infrastructure with advanced cybersecurity services and vulnerability audits.",
        services: {
          title: "Cybersecurity Services",
          penetrationTesting: "Penetration testing",
          vulnerabilityAssessment: "Vulnerability assessment",
          securityAudit: "Security audit",
          incidentResponse: "Incident response",
          compliance: "Regulatory compliance"
        },
        tools: {
          title: "Security Tools"
        },
        process: {
          title: "Our Process",
          reconnaissance: "Reconnaissance",
          reconnaissanceDesc: "We gather information about the target infrastructure",
          scanning: "Scanning",
          scanningDesc: "We identify open ports and vulnerable services",
          analysis: "Analysis",
          analysisDesc: "We analyze the vulnerabilities found",
          reporting: "Reporting",
          reportingDesc: "We generate a detailed report with recommendations",
          remediation: "Remediation",
          remediationDesc: "We help fix the identified vulnerabilities"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on security audit scope",
          consult: "Request Quote"
        }
      },
      // E-commerce
      ecommerce: {
        title: "E-commerce",
        subtitle: "We create complete and functional online stores that convert visitors into customers and maximize your sales.",
        features: {
          title: "Key Features",
          catalog: "Advanced product catalog",
          payment: "Payment gateway integration",
          inventory: "Real-time inventory management",
          analytics: "Sales analytics and reports",
          mobile: "Optimized mobile experience"
        },
        platforms: {
          title: "E-commerce Platforms"
        },
        process: {
          title: "Our Process",
          planning: "Planning and Analysis",
          planningDesc: "We analyze your business and define the e-commerce strategy",
          design: "UX/UI Design",
          designDesc: "We create an attractive and functional shopping experience",
          development: "Development",
          developmentDesc: "We develop the store with the best technologies",
          integration: "System Integration",
          integrationDesc: "We connect with payment gateways and management systems",
          launch: "Launch and Optimization",
          launchDesc: "We launch the store and optimize for conversions"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on online store complexity",
          consult: "Request Quote"
        }
      },
      // Social Media Marketing
      socialMedia: {
        title: "Social Media Marketing",
        subtitle: "We manage your social media presence to increase your visibility and engagement with your audience.",
        services: {
          title: "Digital Marketing Services",
          strategy: "Social media strategy",
          content: "Attractive content creation",
          ads: "Paid social media advertising",
          community: "Community management",
          analytics: "Analytics and reporting"
        },
        platforms: {
          title: "Social Platforms"
        },
        process: {
          title: "Our Process",
          audit: "Social Media Audit",
          auditDesc: "We analyze your current social media presence",
          strategy: "Strategy Development",
          strategyDesc: "We create a personalized strategy for your brand",
          content: "Content Creation",
          contentDesc: "We develop attractive and relevant content",
          management: "Daily Management",
          managementDesc: "We professionally manage your social media",
          optimization: "Continuous Optimization",
          optimizationDesc: "We constantly improve based on results"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom monthly plans based on your needs",
          consult: "Request Plan"
        }
      },
      // Process Automation
      automation: {
        title: "Process Automation",
        subtitle: "We automate repetitive processes to improve operational efficiency and reduce your company's costs.",
        features: {
          title: "Key Features",
          rpa: "Robotic Process Automation (RPA)",
          workflow: "Workflow automation",
          integration: "Integration with existing systems",
          monitoring: "Real-time monitoring and reporting",
          scalability: "Scalability and flexibility"
        },
        technologies: {
          title: "Technologies"
        },
        process: {
          title: "Our Process",
          analysis: "Process Analysis",
          analysisDesc: "We identify processes candidates for automation",
          design: "Solution Design",
          designDesc: "We design the optimal automation architecture",
          development: "Development",
          developmentDesc: "We develop bots and automated workflows",
          testing: "Testing and Validation",
          testingDesc: "We test exhaustively in controlled environments",
          deployment: "Deployment and Monitoring",
          deploymentDesc: "We implement and monitor performance"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on process complexity",
          consult: "Request Quote"
        }
      },
      // Corporate Marketing
      corporateMarketing: {
        title: "Corporate Marketing",
        subtitle: "We develop B2B and corporate marketing strategies to position your company in the business market.",
        services: {
          title: "B2B Marketing Services",
          branding: "Corporate branding and positioning",
          strategy: "B2B marketing strategies",
          content: "Content marketing and thought leadership",
          digital: "Digital marketing for companies",
          analytics: "B2B analytics and metrics"
        },
        channels: {
          title: "Corporate Channels"
        },
        process: {
          title: "Our Process",
          audit: "Brand Audit",
          auditDesc: "We analyze your current positioning in the B2B market",
          strategy: "Strategy Development",
          strategyDesc: "We create a personalized corporate marketing strategy",
          implementation: "Implementation",
          implementationDesc: "We execute B2B marketing campaigns and strategies",
          optimization: "Continuous Optimization",
          optimizationDesc: "We constantly improve based on metrics and results"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom plans based on your company size and sector",
          consult: "Request Plan"
        }
      },
      // Digital Training for Executives
      digitalTraining: {
        title: "Digital Training for Executives",
        subtitle: "We train executives and business leaders in the latest digital and technological trends.",
        programs: {
          title: "Training Programs",
          strategy: "Business digital strategy",
          transformation: "Digital transformation",
          innovation: "Technology innovation",
          leadership: "Digital leadership",
          analytics: "Analytics for executives"
        },
        methodologies: {
          title: "Methodologies"
        },
        process: {
          title: "Our Process",
          assessment: "Needs Assessment",
          assessmentDesc: "We analyze the specific training needs of your executive team",
          customization: "Customization",
          customizationDesc: "We adapt the program to your industry and business objectives",
          implementation: "Implementation",
          implementationDesc: "We execute training sessions with practical methodologies",
          followup: "Follow-up and Support",
          followupDesc: "We provide continuous follow-up and post-training support"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom programs based on number of participants and duration",
          consult: "Request Program"
        }
      },
      // SME Digitalization
      smeDigitalization: {
        title: "SME Digitalization",
        subtitle: "We help small and medium enterprises digitize their processes and compete in the digital market.",
        solutions: {
          title: "Digital Solutions",
          erp: "ERP systems adapted for SMEs",
          crm: "Customer management and CRM",
          ecommerce: "E-commerce and online stores",
          automation: "Process automation",
          cloud: "Cloud migration"
        },
        benefits: {
          title: "Benefits"
        },
        process: {
          title: "Our Process",
          diagnosis: "Digital Diagnosis",
          diagnosisDesc: "We evaluate the current digitalization status of your SME",
          planning: "Strategic Planning",
          planningDesc: "We develop a personalized digitalization roadmap",
          implementation: "Gradual Implementation",
          implementationDesc: "We implement digital solutions progressively",
          support: "Continuous Support",
          supportDesc: "We provide technical support and continuous training"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Scalable solutions based on your SME size and needs",
          consult: "Request Solution"
        }
      },
      // Data Analytics & Business Intelligence
      dataAnalytics: {
        title: "Data Analytics & BI",
        subtitle: "We transform data into valuable insights for strategic business decision making.",
        services: {
          title: "Analytics Services",
          dataWarehouse: "Data warehouse construction",
          dashboards: "Interactive dashboards and reports",
          reporting: "Automated reporting and KPIs",
          predictive: "Predictive analytics and forecasting",
          dataIntegration: "Data integration and cleaning"
        },
        tools: {
          title: "BI Tools"
        },
        process: {
          title: "Our Process",
          assessment: "Data Assessment",
          assessmentDesc: "We analyze your data sources and reporting needs",
          architecture: "Data Architecture",
          architectureDesc: "We design the optimal data architecture for your business",
          development: "Development",
          developmentDesc: "We build custom data warehouses and dashboards",
          deployment: "Deployment and Configuration",
          deploymentDesc: "We implement and configure BI tools",
          training: "Training and Support",
          trainingDesc: "We train your team in using the tools"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on analysis complexity",
          consult: "Request Quote"
        }
      },
      // System Integration
      systemIntegration: {
        title: "System Integration",
        subtitle: "We connect your business systems to optimize workflows and improve efficiency.",
        services: {
          title: "Integration Services",
          apiDevelopment: "Custom API development",
          dataSync: "Data synchronization between systems",
          workflow: "Workflow automation",
          legacy: "Legacy system integration",
          monitoring: "Monitoring and maintenance"
        },
        platforms: {
          title: "Integration Platforms"
        },
        process: {
          title: "Our Process",
          analysis: "System Analysis",
          analysisDesc: "We evaluate your current systems and integration needs",
          architecture: "Integration Architecture",
          architectureDesc: "We design the most efficient integration architecture",
          development: "Development",
          developmentDesc: "We develop integrations and necessary APIs",
          testing: "Testing and Validation",
          testingDesc: "We thoroughly test all integrations",
          deployment: "Deployment and Monitoring",
          deploymentDesc: "We implement and monitor performance"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on integration complexity",
          consult: "Request Quote"
        }
      },
      // APIs & Microservices
      apiMicroservices: {
        title: "APIs & Microservices",
        subtitle: "We develop robust APIs and microservices architectures for scalable applications.",
        services: {
          title: "Development Services",
          restApis: "RESTful API development",
          graphql: "Modern GraphQL APIs",
          microservices: "Microservices architecture",
          serverless: "Serverless functions",
          documentation: "Complete technical documentation"
        },
        technologies: {
          title: "Technologies"
        },
        process: {
          title: "Our Process",
          planning: "Planning and Analysis",
          planningDesc: "We analyze requirements and design the architecture",
          design: "API Design",
          designDesc: "We design the API structure and endpoints",
          development: "Development",
          developmentDesc: "We develop APIs and microservices with best practices",
          testing: "Testing and QA",
          testingDesc: "We perform unit, integration, and load testing",
          deployment: "Deployment and CI/CD",
          deploymentDesc: "We implement with automated CI/CD pipelines"
        },
        pricing: {
          title: "Pricing",
          startingFrom: "Starting from",
          description: "Custom pricing based on API complexity",
          consult: "Request Quote"
        }
      }
    },

    // Success Cases Section
    successCases: {
      title: "Success Cases",
      subtitle: "Discover how we've helped our clients achieve their goals and transform their businesses with innovative technological solutions.",
      cases: [
        {
          title: "Multi-platform E-commerce",
          client: "TechRetail Solutions",
          description: "We developed a complete e-commerce platform with multi-channel sales integration, inventory management system, and advanced data analytics.",
          results: [
            "300% increase in online sales",
            "40% reduction in operational costs",
            "85% improvement in loading time"
          ]
        },
        {
          title: "Logistics Management App",
          client: "LogiTech Express",
          description: "We created a mobile application to optimize delivery routes, real-time tracking, and vehicle fleet management.",
          results: [
            "60% optimization in delivery routes",
            "25% reduction in fuel costs",
            "90% improvement in customer satisfaction"
          ]
        },
        {
          title: "AI System for Predictive Analytics",
          client: "DataInsight Corp",
          description: "We implemented an artificial intelligence system to predict market trends and optimize investment strategies.",
          results: [
            "87% accuracy in predictions",
            "450% ROI in the first year",
            "70% automation of decisions"
          ]
        }
      ],
      keyResults: "Key Results:",
      technologies: "Technologies Used:",
      cta: {
        title: "Want to be our next success case?",
        subtitle: "Join the list of satisfied clients who have transformed their businesses with our technological solutions.",
        button: "Start Your Project"
      }
    },

    // Contact Section
    contact: {
      title: "Contact Us",
      subtitle: "Ready to transform your business? We're here to help you make your digital vision a reality.",
      project: {
        title: "Let's Talk About Your Project",
        description: "Our team of experts is ready to listen to your needs and create a personalized solution that drives your business towards success."
      },
      methods: {
        meeting: {
          title: "Schedule a Meeting",
          description: "Schedule a free 30-minute consultation to discuss your project.",
          button: "Book Appointment"
        },
        email: {
          title: "Send us an Email",
          description: "Tell us about your project and we'll respond within 24 hours."
        }
      },
      consultation: {
        title: "What's included in the free consultation?",
        items: [
          "Analysis of your specific needs",
          "Personalized solution proposal",
          "Time and budget estimation",
          "No commitment or hidden costs"
        ]
      },
      ready: {
        title: "Ready to Start?",
        description: "Our team is waiting to help you make your project a reality. Don't wait any longer to transform your vision into reality!",
        scheduleButton: "Schedule Free Consultation",
        emailButton: "Send Email"
      }
    },

    // Footer
    footer: {
      copyright: "© Xperiecia Consulting 2025. All rights reserved.",
      tagline: "Transforming ideas into innovative digital solutions"
    },

    // Login
    login: {
      title: "Access",
      subtitle: "Sign in to access your personal area",
      email: "Email",
      emailPlaceholder: "your@email.com",
      password: "Password",
      passwordPlaceholder: "Your password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      backToHome: "Back to Home",
      demoCredentials: "Demo Credentials",
      continueWith: "or continue with",
      connectWithGoogle: "Connecting with Google...",
      signInWithGoogle: "Sign in with Google",
      googleError: "Error signing in with Google. Please try again.",
      credentialsError: "Incorrect credentials. Please verify your email and password.",
      accountCreatedSuccess: "Account created and signed in with Google!",
      signInSuccess: "Signed in with Google!",
      demoEmailAdmin: "Admin Email:",
      demoEmailClient: "Client Email:",
      demoPassword: "Password:",
      noAccount: "Don't have an account?",
      createAccount: "Create account",
      alreadyHaveAccount: "Already have an account?",
      signInHere: "Sign in here"
    },

    // Register
    register: {
      title: "Register",
      subtitle: "Create your account to access our services",
      name: "Full name",
      namePlaceholder: "Your full name",
      email: "Email",
      emailPlaceholder: "your@email.com",
      company: "Company (optional)",
      companyPlaceholder: "Your company name",
      phone: "Phone (optional)",
      phonePlaceholder: "+1234567890",
      password: "Password",
      passwordPlaceholder: "Minimum 6 characters",
      confirmPassword: "Confirm password",
      confirmPasswordPlaceholder: "Repeat your password",
      createAccount: "Create account",
      creatingAccount: "Creating account...",
      registerWithGoogle: "Register with Google",
      connectingWithGoogle: "Connecting with Google...",
      termsText: "By registering, you accept our terms and conditions. Your information will only be used to manage your budget requests and projects.",
      orRegisterWith: "or register with",
      alreadyHaveAccount: "Already have an account?",
      signInHere: "Sign in",
      successMessage: "Registration successful! You can now sign in.",
      errorMessage: "Error registering user",
      emailExistsError: "This email is already registered",
      invalidDataError: "Invalid data. Please verify the information",
      serverError: "Server error. Please try again later",
      googleError: "Error registering with Google. Please try again.",
      googleConnectError: "Error connecting with Google. Please try again.",
      accountCreatedSuccess: "Account created and signed in with Google!",
      signInSuccess: "Signed in with Google!"
    },

    // Dashboard
    dashboard: {
      title: "Administration Panel",
      subtitle: "Manage projects, clients and company resources",
      welcome: "Welcome",
      backToHome: "Back to Home",
      logout: "Logout",
      stats: {
        activeProjects: "Active Projects",
        totalClients: "Total Clients",
        monthlyRevenue: "Monthly Revenue"
      }
    },

    // Project Management
    projectManagement: {
      title: "Project Management",
      subtitle: "Manage and supervise all active projects",
      newProject: "New Project",
      backToDashboard: "Back to Dashboard",
      stats: {
        totalProjects: "Total Projects",
        inProgress: "In Progress",
        completed: "Completed",
        totalBudget: "Total Budget",
        totalSpent: "Total Spent"
      },
      filters: {
        searchPlaceholder: "Search projects...",
        allStatuses: "All statuses",
        planning: "Planning",
        inProgress: "In Progress",
        inReview: "In Review",
        completed: "Completed",
        cancelled: "Cancelled"
      },
      table: {
        project: "Project",
        client: "Client",
        status: "Status",
        progress: "Progress",
        budget: "Budget",
        priority: "Priority",
        actions: "Actions"
      },
      priorities: {
        low: "Low",
        medium: "Medium",
        high: "High",
        critical: "Critical"
      },
      modal: {
        newProject: "New Project",
        editProject: "Edit Project",
        projectName: "Project Name",
        client: "Client",
        status: "Status",
        startDate: "Start Date",
        endDate: "End Date",
        budget: "Budget (€)",
        priority: "Priority",
        description: "Description",
        cancel: "Cancel",
        createProject: "Create Project",
        saveChanges: "Save Changes",
        deleteConfirm: "Are you sure you want to delete this project?"
      },
      jira: {
        title: "Integración con Jira",
        configure: "Configurar Jira",
        viewJira: "Ver Jira",
        disconnect: "Desconectar Jira",
        configModal: {
          title: "Configurar Integración con Jira",
          url: "URL de Jira",
          urlPlaceholder: "https://tuempresa.atlassian.net",
          email: "Email",
          emailPlaceholder: "tu-email@empresa.com",
          apiToken: "API Token",
          apiTokenPlaceholder: "Tu API token de Jira",
          projectKey: "Clave del Proyecto",
          projectKeyPlaceholder: "PROJ",
          boardId: "ID del Tablero",
          boardIdPlaceholder: "123",
          infoTitle: "Información importante",
          infoText: "Para obtener tu API token de Jira:",
          infoSteps: [
            "Ve a https://id.atlassian.com/manage-profile/security/api-tokens",
            "Crea un nuevo token",
            "Copia el token y pégalo aquí"
          ],
          saveConfig: "Guardar Configuración",
          cancel: "Cancelar"
        },
        viewModal: {
          title: "Jira - {projectName}",
          lastSync: "Última sincronización: {date}",
          openInJira: "Abrir en Jira",
          close: "Cerrar",
          metrics: {
            totalIssues: "Issues Totales",
            activeSprints: "Sprints Activos",
            currentVelocity: "Velocidad Actual",
            pendingIssues: "Issues Pendientes"
          },
          issues: {
            title: "Issues Recientes",
            issue: "Issue",
            summary: "Resumen",
            status: "Estado",
            assignee: "Asignado",
            priority: "Prioridad",
            type: "Tipo",
            statuses: {
              done: "Done",
              inProgress: "In Progress",
              toDo: "To Do"
            },
            priorities: {
              high: "High",
              medium: "Medium",
              low: "Low"
            },
            types: {
              story: "Story",
              bug: "Bug",
              task: "Task"
            }
          },
          sprints: {
            title: "Sprints",
            startDate: "Inicio",
            endDate: "Fin",
            completed: "Completadas",
            progress: "Progreso",
            states: {
              active: "Activo",
              future: "Futuro",
              completed: "Completado"
            }
          }
        },
        disconnectConfirm: "¿Estás seguro de que quieres desconectar la integración con Jira?"
      }
    },

    // Client Management
    clientManagement: {
      title: "Client Management",
      subtitle: "Manage your client database and prospects",
      newClient: "New Client",
      backToDashboard: "Back to Dashboard",
      stats: {
        totalClients: "Total Clients",
        activeClients: "Active Clients",
        prospects: "Prospects",
        inactiveClients: "Inactive Clients",
        totalRevenue: "Total Revenue",
        totalProjects: "Total Projects"
      },
      filters: {
        searchPlaceholder: "Search clients...",
        allStatuses: "All statuses",
        allIndustries: "All industries"
      },
      statuses: {
        active: "Active",
        prospect: "Prospect",
        inactive: "Inactive",
        suspended: "Suspended"
      },
      table: {
        client: "Client",
        contact: "Contact",
        industry: "Industry",
        status: "Status",
        projects: "Projects",
        revenue: "Revenue",
        lastContact: "Last Contact",
        actions: "Actions"
      },
      modal: {
        newClient: "New Client",
        editClient: "Edit Client",
        clientName: "Client Name",
        contactPerson: "Contact Person",
        email: "Email",
        phone: "Phone",
        company: "Company",
        industry: "Industry",
        status: "Status",
        address: "Address",
        website: "Website",
        notes: "Notes",
        cancel: "Cancel",
        createClient: "Create Client",
        saveChanges: "Save Changes",
        deleteConfirm: "Are you sure you want to delete this client?"
      }
    },

    // Reports & Analytics
    reportsAnalytics: {
      title: "Reports & Analytics",
      subtitle: "View key metrics, trends, and company activity",
      monthlyRevenue: "Monthly Revenue",
      activeProjects: "Active Projects",
      newClients: "New Clients",
      supportTickets: "Support Tickets",
      dateRanges: {
        last12Months: "Last 12 months",
        last6Months: "Last 6 months",
        last3Months: "Last 3 months",
        lastMonth: "Last month"
      },
      serviceFilters: {
        allServices: "All services"
      },
      charts: {
        monthlyRevenue: "Monthly Revenue",
        projectsByService: "Projects by Service",
        projectsAndClients: "Projects & Clients per Month",
        topClients: "Top Clients by Revenue"
      },
      table: {
        client: "Client",
        projects: "Projects",
        revenue: "Revenue"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },

    // WhatsApp Button
    whatsapp: {
      tooltip: "Chat with us!"
    },

    // Client Portal
    client: {
      portal: "Portal",
      menu: "Menú",
      logout: "Cerrar Sesión",
      dashboard: "Dashboard",
      budgets: "Presupuestos",
      services: "Servicios",
      projects: "Proyectos",
      support: "Soporte",
      analytics: "Analíticas",
      profile: "Perfil",
      delivered: "Entregado",
      ready: "Listo",
      userTraining: "Formación de Usuario",
      open: "Abierto",
      hubApps: "Hub de Aplicaciones",
      
      // Dashboard
      welcomeBack: "Bienvenido de vuelta",
      clientName: "Juan Carlos",
      dashboardSubtitle: "Aquí tienes un resumen de tus proyectos y servicios activos",
      activeBudgets: "Presupuestos Activos",
      activeServices: "Servicios Activos",
      activeProjects: "Proyectos Activos",
      openTickets: "Tickets Abiertos",
      fromLastMonth: "vs mes anterior",
      recentBudgets: "Presupuestos Recientes",
      activeProjectsTitle: "Proyectos Activos",
      viewAll: "Ver Todos",
      websiteRedesign: "Rediseño de Web",
      mobileApp: "App Móvil",
      cloudMigration: "Migración Cloud",
      ecommercePlatform: "Plataforma E-commerce",
      crmIntegration: "Integración CRM",
      progress: "Progreso",
      dueDate: "Fecha de Entrega",
      quickActions: "Acciones Rápidas",
      requestBudget: "Solicitar Presupuesto",
      createTicket: "Crear Ticket",
      requestService: "Solicitar Servicio",
      viewInvoices: "Ver Facturas",
      
    }
  }
}; 